import { gql } from 'urql';

//SoftPull Polling
const GetLineOfCreditSoftPullCompleteStatus = gql`
  query GetLineOfCreditSoftPullCompleteStatus {
    hasCompletedSoftCheck {
      ... on GetSoftCreditCheckExistenceSuccess {
        __typename
        softCreditCheckComplete
      }
      ... on GetSoftCreditCheckExistenceError {
        code
        message
        title
      }
    }
  }
`;

export default GetLineOfCreditSoftPullCompleteStatus;
